/**
 * Retrieve token from session storage
 */
export const initializeInstance = setHttpHeader => {
    let token = null;
    token = sessionStorage.getItem('sessionId');
    if (token) setHttpHeader('Authorization', `Bearer ${token}`);
}

